var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "authenticated" }, [_c("sm-loader")], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.userIdentity && _vm.userIdentity.emailVerificationRequired
      ? _c(
          "div",
          [
            _c("AuthenticatedRequireEmailVerification", {
              attrs: { email: _vm.userIdentity.email },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }